import axios from 'axios';

const edxClient = axios.create({
  baseURL: process.env.REACT_APP_EDX_BASE_URL
});

export default edxClient;
